
import AdminAPI from '../../APIs/AdminAPI/AdminAPI'

export const AdminActions = {
    state: {
        isAuthorizedData: null,
        // utils
        fetchPortalApprovalData: null,
        cancelPortalApprovalData: null,
        listCancelledPortalApprovalsData: null,

        // acu
        acuActiveListData: null,
        acuActiveListAbortController: null,
        acuActiveListRequestId: 0,
        toggleAcuStatusData: null,
        getMsuRatesData: null,
        editMsuRatesData: null,
        deleteMsuRatesData: null,
        addMsuRatesData: null,
        viewAccountCoveragesData: null,
        editAccountCoverageData: null,
        deleteAccountCoverageData: null,
        addAccountCoverageData: null,
        approveAcuStatusData: null,
        fetchAcuProvidersData: null,
        fetchAcuApprovalLogsData: null,
        fetchAcuDisapprovalLogsData: null,
        fetchAcuMemberSummaryData: null,
        fetchAcuAccountSummaryData: null,
        fetchAcuProviderLoginListData: null,
        showAcuAtGlanceData: null,
        downloadAcuApprovalData: null,
        generateAcuReportData: null,
        fetchAcuApprovalData: null,
        revalidateAcuApprovalData: null,
        generateQualifiedListData: null,
        viewAccountClinicsData: null,
        insertAccountClinicData: null,
        approveAccountClinicData: null,
        deleteAccountClinicData: null,
        getStatusProvisionData: null,
        generateEndorsementConfirmationData: null,
        listEndorsementConfirmationData: null,
        signEndorsementConfirmationData: null,
        viewEndorsementConfirmationData: null,
        deleteEndorsementConfirmationData: null,
        deleteMemberFromEndorsementConfirmationData: null,
        getPackageDiagnosticsData: null,
        editDiagnosticPackageData: null,
        deletePackageDiagnosticData: null,
        addDiagnosticToPackageData: null,
        listMsuGroupsData: null,
        editMsuGroupNameData: null,
        viewMsuGroupData: null,
        insertToMsuGroupData: null,
        deleteMsuFromGroupData: null,
        deleteMsuGroupData: null,
        viewProviderAcuInfoData: null,
        editProviderAcuInfoData: null,
        addProviderAcuInfoData: null,
        deleteProviderAcuInfoData: null,
        toggleAcuProgressData: null,
        fetchMembersOfScopedBenefitData: null,
        insertMemberToScopedBenefitData: null,
        removeMemberFromScopedBenefitData: null,
        linkDiagRateData: null,
        unlinkDiagRateData: null,
        viewLinkedDiagRateData: null,
        generateLetterReportData: null,
        extendLetterData: null,
        cancelAcuApprovalData: null,
        listCancelledApprovalData: null,

        // claims
        fetchListLedgersData: null,
        downloadLedgerClaimsData: null,
        viewLedgerData: null,
        providerListClaimsData: null,

        // admin
        editProviderAccountData: null,
        disableProviderAccountData: null,
        downloadApprovalMembData: null,
        downloadApprovalProviderData: null,
        downloadReportMembData: null,
        downloadReportData: null,
        showProviderLoginListData: null,
        showProviderAtGlanceData: null,
        showProviderSummaryData: null,
        showProviderDisapprovalLogsData: null,
        showProviderApprovalLogsData: null,
        recoverPasswordAdminData: null,
        forgotPasswordAdminData: null,
        changePasswordAdminData: null,
        getUserInfoData: null,
        showProviderLinksData: null,
        fetchProvidersData: null,
        unlinkProvidersData: null,
        linkProvidersData: null,
        signupProviderData: null,
        loginData: null,
        adminVerifySignupData: null,
        adminSignupData: null,
        showMemberLoginListData: null,
        showMemberApprovalLogsData: null,
        showMemberDisapprovalLogsData: null,
        showMemberSummaryTableData: null,
        showAccountSummaryTableData: null,
        showMemberAtGlanceData: null,
        showProviderValidationLog: null,
        approveAccountCoverageData: null,
        acudiagnosticsuggestions: null,
        createMsuGroupData: null
    },
    actions: {
        async isAuthorized({ commit }) {
            await AdminAPI.isAuthorized()
                .then(res => {
                    commit('IS_AUTHORIZED', res && res.data)
                })
        },
        /**
         * UTILS
         */
        fetchPortalApproval({ commit }, data) {
            AdminAPI.fetchPortalApproval(data)
                .then(res=>{
                    commit('FETCH_PORTAL_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchPortalApproval error: ', error)
                    commit('FETCH_PORTAL_APPROVAL', [])
                })
        },
        cancelPortalApproval({ commit }, data) {
            AdminAPI.cancelPortalApproval(data)
                .then(res=>{
                    commit('CANCEL_PORTAL_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('cancelPortalApproval error: ', error)
                    commit('CANCEL_PORTAL_APPROVAL', [])
                })
        },
        listCancelledPortalApprovals({ commit }, data) {
            AdminAPI.listCancelledPortalApprovals(data)
                .then(res=>{
                    commit('LIST_CANCELLED_PORTAL_APPROVALS', res && res.data)
                })
                .catch(()=>{
                    // console.error('listCancelledPortalApprovals error: ', error)
                    commit('LIST_CANCELLED_PORTAL_APPROVALS', [])
                })
        },


        /**
         * ACU
        */
        listCancelledApproval({ commit }, data) {
            AdminAPI.listCancelledApproval(data)
                .then(res=>{
                    commit('LIST_CANCELLED_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('listCancelledApproval error: ', error)
                    commit('LIST_CANCELLED_APPROVAL', [])
                })
        },
        cancelAcuApproval({ commit }, data) {
            AdminAPI.cancelAcuApproval(data)
                .then(res=>{
                    commit('CANCEL_ACU_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('cancelAcuApproval error: ', error)
                    commit('CANCEL_ACU_APPROVAL', [])
                })
        },
        extendLetter({ commit }, data) {
            AdminAPI.extendLetter(data)
                .then(res=>{
                    commit('EXTEND_LETTER', res && res.data)
                })
                .catch(()=>{
                    // console.error('extendLetter error: ', error)
                    commit('EXTEND_LETTER', [])
                })
        },
        generateLetterReport({ commit }, data) {
            AdminAPI.generateLetterReport(data)
                .then(res=>{
                    commit('GENERATE_LETTER_REPORT', res && res.data)
                })
                .catch(()=>{
                    // console.error('generateLetterReport error: ', error)
                    commit('GENERATE_LETTER_REPORT', [])
                })
        },
        unlinkDiagRate({ commit }, data) {
            AdminAPI.unlinkDiagRate(data)
                .then(res=>{
                    commit('UNLINK_DIAG_RATE', res && res.data)
                })
                .catch(()=>{
                    // console.error('unlinkDiagRate error: ', error)
                    commit('UNLINK_DIAG_RATE', [])
                })
        },
        async linkDiagRate({ commit }, data) {
            await AdminAPI.linkDiagRate(data)
                .then(res=>{
                    commit('LINK_DIAG_RATE', res && res.data)
                })
                .catch(()=>{
                    // console.error('linkDiagRate error: ', error)
                    commit('LINK_DIAG_RATE', [])
                })
        },
        async viewLinkedDiagRate({ commit }, data) {
            await AdminAPI.viewLinkedDiagRate(data)
                .then(res=>{
                    commit('VIEW_LINKED_DIAGRATE', res && res.data)
                })
                .catch(()=>{
                    // console.error('viewLinkedDiagRate error: ', error)
                    commit('VIEW_LINKED_DIAGRATE', [])
                })
        },
        removeMemberFromScopedBenefit({ commit }, data) {
            AdminAPI.removeMemberFromScopedBenefit(data)
                .then(res=>{
                    commit('REMOVE_MEMBER_FROM_SCOPED_BENEFIT', res && res.data)
                })
                .catch(()=>{
                    // console.error('removeMemberFromScopedBenefit error: ', error)
                    commit('REMOVE_MEMBER_FROM_SCOPED_BENEFIT', [])
                })
        },
        async toggleAcuProgress({ commit }, data) {
            await AdminAPI.toggleAcuProgress(data)
                .then(res=>{
                    commit('TOGGLE_ACU_PROGRESS', res && res.data)
                })
                .catch(()=>{
                    // console.error('toggleAcuProgress error: ', error)
                    commit('TOGGLE_ACU_PROGRESS', [])
                })
        },
        async insertMemberToScopedBenefit({ commit }, data) {
            await AdminAPI.insertMemberToScopedBenefit(data)
                .then(res=>{
                    commit('INSERT_MEMBER_TO_SCOPED_BENEFIT', res && res.data)
                })
                .catch(()=>{
                    // console.error('insertMemberToScopedBenefit error: ', error)
                    commit('INSERT_MEMBER_TO_SCOPED_BENEFIT', [])
                })
        },
        fetchMembersOfScopedBenefit({ commit }, data) {
            AdminAPI.fetchMembersOfScopedBenefit(data)
                .then(res=>{
                    commit('FETCH_MEMBERS_OF_SCOPED_BENEFIT', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchMembersOfScopedBenefit error: ', error)
                    commit('FETCH_MEMBERS_OF_SCOPED_BENEFIT', [])
                })
        },
        deleteProviderAcuInfo({ commit }, data) {
            AdminAPI.deleteProviderAcuInfo(data)
                .then(res=>{
                    commit('DELETE_PROVIDER_ACU_INFO', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteProviderAcuInfo error: ', error)
                    commit('DELETE_PROVIDER_ACU_INFO', [])
                })
        },
        addProviderAcuInfo({ commit }, data) {
            AdminAPI.addProviderAcuInfo(data)
                .then(res=>{
                    commit('ADD_PROVIDER_ACU_INFO', res && res.data)
                })
                .catch(()=>{
                    // console.error('addProviderAcuInfo error: ', error)
                    commit('ADD_PROVIDER_ACU_INFO', [])
                })
        },
        editProviderAcuInfo({ commit }, data) {
            AdminAPI.editProviderAcuInfo(data)
                .then(res=>{
                    commit('EDIT_PROVIDER_ACU_INFO', res && res.data)
                })
                .catch(()=>{
                    // console.error('editProviderAcuInfo error: ', error)
                    commit('EDIT_PROVIDER_ACU_INFO', [])
                })
        },
        viewProviderAcuInfo({ commit }, data) {
            AdminAPI.viewProviderAcuInfo(data)
                .then(res=>{
                    commit('VIEW_PROVIDER_ACU_INFO', res && res.data)
                })
                .catch(()=>{
                    // console.error('viewProviderAcuInfo error: ', error)
                    commit('VIEW_PROVIDER_ACU_INFO', [])
                })
        },
        createMsuGroup({ commit }, data) {
            AdminAPI.createMsuGroup(data)
                .then(res=>{
                    commit('CREATE_MSU_GROUP', res && res.data)
                })
                .catch(()=>{
                    // console.error('createMsuGroup error: ', error)
                    commit('CREATE_MSU_GROUP', [])
                })
        },
        deleteMsuGroup({ commit }, data) {
            AdminAPI.deleteMsuGroup(data)
                .then(res=>{
                    commit('DELETE_MSU_GROUP', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteMsuGroup error: ', error)
                    commit('DELETE_MSU_GROUP', [])
                })
        },
        deleteMsuFromGroup({ commit }, data) {
            AdminAPI.deleteMsuFromGroup(data)
                .then(res=>{
                    commit('DELETE_MSU_FROM_GROUP', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteMsuFromGroup error: ', error)
                    commit('DELETE_MSU_FROM_GROUP', [])
                })
        },
        async insertToMsuGroup({ commit }, data) {
            await AdminAPI.insertToMsuGroup(data)
                .then(res=>{
                    commit('INSERT_TO_MSU_GROUP', res && res.data)
                })
                .catch(()=>{
                    // console.error('insertToMsuGroup error: ', error)
                    commit('INSERT_TO_MSU_GROUP', [])
                })
        },
        async viewMsuGroup({ commit }, data) {
            await AdminAPI.viewMsuGroup(data)
                .then(res=>{
                    commit('VIEW_MSU_GROUP', res && res.data)
                })
                .catch(()=>{
                    // console.error('viewMsuGroup error: ', error)
                    commit('VIEW_MSU_GROUP', [])
                })
        },
        editMsuGroupName({ commit }, data) {
            AdminAPI.editMsuGroupName(data)
                .then(res=>{
                    commit('EDIT_MSU_GROUP_NAME', res && res.data)
                })
                .catch(()=>{
                    // console.error('editMsuGroupName error: ', error)
                    commit('EDIT_MSU_GROUP_NAME', [])
                })
        },
        listMsuGroups({ commit }, data) {
            AdminAPI.listMsuGroups(data)
                .then(res=>{
                    commit('LIST_MSU_GROUPS', res && res.data)
                })
                .catch(()=>{
                    // console.error('listMsuGroups error: ', error)
                    commit('LIST_MSU_GROUPS', [])
                })
        },
        addDiagnosticToPackage({ commit }, data) {
            AdminAPI.addDiagnosticToPackage(data)
                .then(res=>{
                    commit('ADD_DIAGNOSTIC_TO_PACKAGE', res && res.data)
                })
                .catch(()=>{
                    // console.error('addDiagnosticToPackage error: ', error)
                    commit('ADD_DIAGNOSTIC_TO_PACKAGE', [])
                })
        },
        deletePackageDiagnostic({ commit }, data) {
            AdminAPI.deletePackageDiagnostic(data)
                .then(res=>{
                    commit('DELETE_PACKAGE_DIAGNOSTIC', res && res.data)
                })
                .catch(()=>{
                    // console.error('deletePackageDiagnostic error: ', error)
                    commit('DELETE_PACKAGE_DIAGNOSTIC', [])
                })
        },
        editDiagnosticPackage({ commit }, data) {
            AdminAPI.editDiagnosticPackage(data)
                .then(res=>{
                    commit('EDIT_DIAGNOSTIC_PACKAGE', res && res.data)
                })
                .catch(()=>{
                    // console.error('editDiagnosticPackage error: ', error)
                    commit('EDIT_DIAGNOSTIC_PACKAGE', [])
                })
        },
        getPackageDiagnostics({ commit }, data) {
            AdminAPI.getPackageDiagnostics(data)
                .then(res=>{
                    commit('GET_PACKAGE_DIAGNOSTICS', res && res.data)
                })
                .catch(()=>{
                    // console.error('getPackageDiagnostics error: ', error)
                    commit('GET_PACKAGE_DIAGNOSTICS', [])
                })
        },
        deleteEndorsementConfirmation({ commit }, data) {
            AdminAPI.deleteEndorsementConfirmation(data)
                .then(res=>{
                    commit('DELETE_ENDORSEMENT_CONFIRMATION', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteEndorsementConfirmation error: ', error)
                    commit('DELETE_ENDORSEMENT_CONFIRMATION', [])
                })
        },
        deleteMemberFromEndorsementConfirmation({ commit }, data) {
            AdminAPI.deleteMemberFromEndorsementConfirmation(data)
                .then((res) => {
                    commit('DELETE_MEMBER_ENDORSEMENT_CONFIRMATION', res && res.data)
                })
                .catch(()=> {
                    commit('DELETE_MEMBER_ENDORSEMENT_CONFIRMATION', [])
                })
        },
        viewEndorsementConfirmation({ commit }, data) {
            AdminAPI.viewEndorsementConfirmation(data)
                .then(res=>{
                    commit('VIEW_ENDORSEMENT_CONFIRMATION', res && res.data)
                })
                .catch(()=>{
                    // console.error('viewEndorsementConfirmation error: ', error)
                    commit('VIEW_ENDORSEMENT_CONFIRMATION', [])
                })
        },
        signEndorsementConfirmation({ commit }, data) {
            AdminAPI.signEndorsementConfirmation(data)
                .then(res=>{
                    commit('SIGN_ENDORSEMENT_CONFIRMATION', res && res.data)
                })
                .catch(()=>{
                    // console.error('signEndorsementConfirmation error: ', error)
                    commit('SIGN_ENDORSEMENT_CONFIRMATION', [])
                })
        },
        listEndorsementConfirmation({ commit }) {
            AdminAPI.listEndorsementConfirmation()
                .then(res=>{
                    commit('LIST_ENDORSEMENT_CONFIRMATION', res && res.data)
                })
                .catch(()=>{
                    // console.error('listEndorsementConfirmation error: ', error)
                    commit('LIST_ENDORSEMENT_CONFIRMATION', [])
                })
        },
        generateEndorsementConfirmation({ commit }, data) {
            AdminAPI.generateEndorsementConfirmation(data)
                .then(res=>{
                    commit('GENERATE_ENDORSEMENT_CONFIRMATION', res && res.data)
                })
                .catch(()=>{
                    // console.error('generateEndorsementConfirmation error: ', error)
                    commit('GENERATE_ENDORSEMENT_CONFIRMATION', [])
                })
        },
        async getStatusProvision({ commit }, data) {
            await AdminAPI.getStatusProvision(data)
                .then(res=>{
                    commit('GET_STATUS_PROVISION', res && res.data)
                })
                .catch(()=>{
                    // console.error('getStatusProvision error: ', error)
                    commit('GET_STATUS_PROVISION', [])
                })
        },
        deleteAccountClinic({ commit }, data) {
            AdminAPI.deleteAccountClinic(data)
                .then(res=>{
                    commit('DELETE_ACCOUNT_CLINIC', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteAccountClinic error: ', error)
                    commit('DELETE_ACCOUNT_CLINIC', [])
                })
        },
        approveAccountClinic({ commit }, data) {
            AdminAPI.approveAccountClinic(data)
                .then(res=>{
                    commit('APPROVE_ACCOUNT_CLINIC', res && res.data)
                })
                .catch(()=>{
                    // console.error('approveAccountClinic error: ', error)
                    commit('APPROVE_ACCOUNT_CLINIC', [])
                })
        },
        insertAccountClinic({ commit }, data) {
            AdminAPI.insertAccountClinic(data)
                .then(res=>{
                    commit('INSERT_ACCOUNT_CLINIC', res && res.data)
                })
                .catch(()=>{
                    // console.error('insertAccountClinic error: ', error)
                    commit('INSERT_ACCOUNT_CLINIC', [])
                })
        },
        async viewAccountClinics({ commit }, data) {
            await AdminAPI.viewAccountClinics(data)
                .then(res=>{
                    commit('VIEW_ACCOUNT_CLINICS', res && res.data)
                })
                .catch(()=>{
                // console.error('viewAccountClinics error: ', error)
                    commit('VIEW_ACCOUNT_CLINICS', [])
                })
        },
        generateQualifiedList({ commit }, data) {
            AdminAPI.generateQualifiedList(data)
                .then(res=>{
                    commit('GENERATE_QUALIFIED_LIST', res && res.data)
                })
                .catch(()=>{
                    // console.error('generateQualifiedList error: ', error)
                    commit('GENERATE_QUALIFIED_LIST', [])
                })
        },
        validateMembersFromExcel({ commit }, data) {
            AdminAPI.validateMembersFromExcel(data)
                .then(res=>{
                    commit('GENERATE_QUALIFIED_LIST', res && res.data)
                })
                .catch(()=>{
                    // console.error('generateQualifiedList error: ', error)
                    commit('GENERATE_QUALIFIED_LIST', [])
                })
        },
        revalidateAcuApproval({ commit }, data) {
            AdminAPI.revalidateAcuApproval(data)
                .then(res=>{
                    commit('REVALIDATE_ACU_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('revalidateAcuApproval error: ', error)
                    commit('REVALIDATE_ACU_APPROVAL', [])
                })
        },
        fetchAcuApproval({ commit }, data) {
            AdminAPI.fetchAcuApproval(data)
                .then(res=>{
                    commit('FETCH_ACU_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchAcuApproval error: ', error)
                    commit('FETCH_ACU_APPROVAL', [])
                })
        },
        downloadAcuApproval({ commit }, data) {
            AdminAPI.downloadAcuApproval(data)
                .then(res=>{
                    commit('DOWNLOAD_ACU_APPROVAL', res && res.data)
                })
                .catch(()=>{
                    // console.error('downloadAcuApproval error: ', error)
                    commit('DOWNLOAD_ACU_APPROVAL', [])
                })
        },
        generateAcuReport({ commit }, data) {
            AdminAPI.generateAcuReport(data)
                .then(res=>{
                    commit('GENERATE_ACU_REPORT', res && res.data)
                })
                .catch(()=>{
                    // console.error('generateAcuReport error: ', error)
                    commit('GENERATE_ACU_REPORT', [])
                })
        },
        async showAcuAtGlance({ commit }, data) {
            await AdminAPI.showAcuAtGlance(data)
                .then(res=>{
                    commit('SHOW_ACU_AT_GLANCE', res && res.data)
                })
                .catch(()=>{
                    // console.error('showAcuAtGlance error: ', error)
                    commit('SHOW_ACU_AT_GLANCE', [])
                })
        },
        async fetchAcuAccountSummary({ commit }, data) {
            await AdminAPI.fetchAcuAccountSummary(data)
                .then(res=>{
                    commit('FETCH_ACU_ACCOUNT_SUMMARY', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchAcuAccountSummary error: ', error)
                    commit('FETCH_ACU_ACCOUNT_SUMMARY', [])
                })
        },
        async fetchAcuMemberSummary({ commit }, data) {
            await AdminAPI.fetchAcuMemberSummary(data)
                .then(res=>{
                    commit('FETCH_ACU_MEMBER_SUMMARY', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchAcuMemberSummary error: ', error)
                    commit('FETCH_ACU_MEMBER_SUMMARY', [])
                })
        },
        async fetchAcuDisapprovalLogs({ commit }, data) {
            await AdminAPI.fetchAcuDisapprovalLogs(data)
                .then(res=>{
                    commit('FETCH_ACU_DISAPPROVAL_LOGS', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchAcuDisapprovalLogs error: ', error)
                    commit('FETCH_ACU_DISAPPROVAL_LOGS', [])
                })
        },
        async fetchAcuApprovalLogs({ commit }, data) {
            await AdminAPI.fetchAcuApprovalLogs(data)
                .then(res=>{
                    commit('FETCH_ACU_APPROVAL_LOGS', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchAcuApprovalLogs error: ', error)
                    commit('FETCH_ACU_APPROVAL_LOGS', [])
                })
        },
        async fetchAcuProviderLoginList({ commit }, data) {
            await AdminAPI.fetchAcuProviderLoginList(data)
                .then((res) => {
                    commit('FETCH_ACU_PROVIDERS_LOGIN_LIST', res && res.data)
                })
                .catch(() => {
                    commit('FETCH_ACU_PROVIDERS_LOGIN_LIST', [])
                })
        },
        fetchAcuProviders({ commit }, data) {
            AdminAPI.fetchAcuProviders(data)
                .then(res=>{
                    commit('FETCH_ACU_PROVIDERS', res && res.data)
                })
                .catch(()=>{
                    // console.error('fetchAcuProviders error: ', error)
                    commit('FETCH_ACU_PROVIDERS', [])
                })
        },
        approveAccountCoverage({ commit }, data) {
            AdminAPI.approveAccountCoverage(data)
                .then(res=>{
                    commit('APPROVE_ACCOUNT_COVERAGE', res && res.data)
                })
                .catch(()=>{
                    // console.error('approveAccountCoverage error: ', error)
                    commit('APPROVE_ACCOUNT_COVERAGE', [])
                })
        },
        approveAcuStatus({ commit }, data) {
            AdminAPI.approveAcuStatus(data)
                .then(res=>{
                    commit('APPROVE_ACU_STATUS', res && res.data)
                })
                .catch(()=>{
                    // console.error('approveAcuStatus error: ', error)
                    commit('APPROVE_ACU_STATUS', [])
                })
        },
        async acuActiveList({ commit, state }) {
            // 1. Cancel previous in-flight request
            if (state.acuActiveListAbortController) {
                state.acuActiveListAbortController.abort()
            }

            // 2. Instantiate and store new controller
            const controller = new AbortController()
            commit('SET_ACU_ACTIVE_LIST_ABORT_CONTROLLER', controller)

            commit('BUMP_ACU_ACTIVE_LIST_REQUEST_ID')
            const myRequestId = state.acuActiveListRequestId

            try {
                const res = await AdminAPI.acuActiveList({ signal: controller.signal })
                const responseData = (res && res.data !== undefined) ? res.data : res

                // 3. Commit only if no newer request was dispatched while in-flight
                if (myRequestId === state.acuActiveListRequestId) {
                    commit('ACU_ACTIVE_LIST', responseData)
                } else {
                    console.log('acuActiveList: dropped stale response')
                }
            } catch (error) {
                const isAbort = error && (
                    error.name === 'CanceledError' || 
                    error.name === 'AbortError' || 
                    error.code === 'ERR_CANCELED'
                )
                if (isAbort) {
                    console.log('acuActiveList request canceled cleanly.')
                } else {
                    console.error('acuActiveList error:', error)
                    commit('ACU_ACTIVE_LIST', [])
                }
            } finally {
                if (state.acuActiveListAbortController === controller) {
                    commit('SET_ACU_ACTIVE_LIST_ABORT_CONTROLLER', null)
                }
            }
        },
        cancelAcuActiveList({ state, commit }) {
            if (state.acuActiveListAbortController) {
                state.acuActiveListAbortController.abort()
                commit('SET_ACU_ACTIVE_LIST_ABORT_CONTROLLER', null)
            }
            commit('BUMP_ACU_ACTIVE_LIST_REQUEST_ID')
        },
        async toggleAcuStatus({ commit }, data) {
            await AdminAPI.toggleAcuStatus(data)
                .then(res=>{
                    commit('TOGGLE_ACU_STATUS', res && res.data)
                })
                .catch(()=>{
                    // console.error('toggleAcuStatus error: ', error)
                    commit('TOGGLE_ACU_STATUS', [])
                })
        },
        getMsuRates({ commit }, data) {
            AdminAPI.getMsuRates(data)
                .then(res=>{
                    commit('GET_MSU_RATES', res && res.data)
                })
                .catch(()=>{
                    // console.error('getMsuRates error: ', error)
                    commit('GET_MSU_RATES', [])
                })
        },
        async editMsuRates({ commit }, data) {
            await AdminAPI.editMsuRates(data)
                .then(res=>{
                    commit('EDIT_MSU_RATES', res && res.data)
                })
                .catch(()=>{
                    // console.error('editMsuRates error: ', error)
                    commit('EDIT_MSU_RATES', [])
                })
        },
        async deleteMsuRates({ commit }, data) {
            await AdminAPI.deleteMsuRates(data)
                .then(res=>{
                    commit('DELETE_MSU_RATES', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteMsuRates error: ', error)
                    commit('DELETE_MSU_RATES', [])
                })
        },
        async addMsuRates({ commit }, data) {
            await AdminAPI.addMsuRates(data)
                .then(res=>{
                    commit('ADD_MSU_RATES', res && res.data)
                })
                .catch(()=>{
                    // console.error('addMsuRates error: ', error)
                    commit('ADD_MSU_RATES', [])
                })
        },
        async viewAccountCoverages({ commit }, data) {
            await AdminAPI.viewAccountCoverages(data)
                .then(res=>{
                    commit('VIEW_ACCOUNT_COVERAGES', res && res.data)
                })
                .catch(()=>{
                    // console.error('viewAccountCoverages error: ', error)
                    commit('VIEW_ACCOUNT_COVERAGES', [])
                })
        },
        async editAccountCoverage({ commit }, data) {
            await AdminAPI.editAccountCoverage(data)
                .then(res=>{
                    commit('EDIT_ACCOUNT_COVERAGE', res && res.data)
                })
                .catch(()=>{
                    // console.error('editAccountCoverage error: ', error)
                    commit('EDIT_ACCOUNT_COVERAGE', [])
                })
        },
        async deleteAccountCoverage({ commit }, data) {
            await AdminAPI.deleteAccountCoverage(data)
                .then(res=>{
                    commit('DELETE_ACCOUNT_COVERAGE', res && res.data)
                })
                .catch(()=>{
                    // console.error('deleteAccountCoverage error: ', error)
                    commit('DELETE_ACCOUNT_COVERAGE', [])
                })
        },
        async addAccountCoverage({ commit }, data) {
            await AdminAPI.addAccountCoverage(data)
                .then(res=>{
                    commit('ADD_ACCOUNT_COVERAGE', res && res.data)
                })
                .catch(()=>{
                    // console.error('addAccountCoverage error: ', error)
                    commit('ADD_ACCOUNT_COVERAGE', [])
                })
        },
        suggestAcuDiagnostics({ commit }) {
            AdminAPI.suggestAcuDiagnostics()
                .then((res) => {
                    commit('SUGGEST_ACU_DIAGNOSTICS', res && res.data)
                }).catch(() => {
                    commit('SUGGEST_ACU_DIAGNOSTICS', [])
                })
        },


        /**
         *
         */
        editProviderAccount({ commit }, data) {
            AdminAPI.editProviderAccount(data)
                .then(res=>{
                    commit('EDIT_PROVIDER_ACCOUNT', res && res.data)
                })
                .catch(()=>{
                    // console.error('editProviderAccount error: ', error)
                    commit('EDIT_PROVIDER_ACCOUNT', [])
                })
        },
        disableProviderAccount({ commit }, data) {
            AdminAPI.disableProviderAccount(data)
                .then(res=>{
                    commit('DISABLE_PROVIDER_ACCOUNT', res && res.data)
                })
                .catch(()=>{
                    // console.error('disableProviderAccount error: ', error)
                    commit('DISABLE_PROVIDER_ACCOUNT', [])
                })
        },
        viewLedger({ commit }, data) {
            AdminAPI.viewLedger(data)
                .then(res=>{
                    commit('VIEW_LEDGER', res && res.data)
                })
                .catch(()=>{
                    // console.error('viewLedger error: ', error)
                    commit('VIEW_LEDGER', [])
                })
        },
        downloadLedgerClaims({ commit }, data) {
            AdminAPI.downloadLedgerClaims(data)
                .then(res=>{
                    commit('DOWNLOAD_LEDGER_CLAIMS', res && res.data)
                })
                .catch(()=>{
                    // console.log('Error downloadLedgerClaims: ', error)
                    commit('DOWNLOAD_LEDGER_CLAIMS', [])
                })
        },
        fetchListLedgers({ commit }, payload) {
            AdminAPI.fetchListLedgers(payload)
                .then(res=>{
                    commit('FETCH_LIST_LEDGERS', res && res.data)
                })
                .catch(()=>{
                    // console.log('Error fetchListLedgers: ', error)
                    commit('FETCH_LIST_LEDGERS', [])
                })
        },
        fetchProvidersClaims({ commit }) {
            AdminAPI.fetchListProviderClaims().then((res) => {
                commit('FETCH_LIST_MSU_CLAIMS', res.data)
            })
        },
        downloadApprovalMemb({ commit }, data) {
            AdminAPI.downloadApprovalMemb(data)
                .then(res=>{
                    commit('DOWNLOAD_APPROVAL_MEMB', res && res.data)
                })
                .catch(error=>{
                    // console.error('DownloadApprovalMemb Error: ', error)
                    commit('DOWNLOAD_APPROVAL_MEMB', error)
                })
        },
        downloadApprovalProvider({ commit }, data) {
            AdminAPI.downloadApprovalProvider(data)
                .then(res=>{
                    commit('DOWNLOAD_APPROVAL_PROVIDER', res && res.data)
                })
                .catch(error=>{
                    // console.error('DownloadApprovalProvider Error: ', error)
                    commit('DOWNLOAD_APPROVAL_PROVIDER', error)
                })
        },
        downloadReportMemb({ commit }, data) {
            AdminAPI.downloadReportMemb(data)
                .then(res=>{
                    commit('DOWNLOAD_REPORT_MEMB', res && res.data)
                })
                .catch(error=>{
                    commit('DOWNLOAD_REPORT_MEMB', error)
                })
        },
        downloadReport({ commit }, data) {
            AdminAPI.downloadReport(data)
                .then(res=>{
                    commit('DOWNLOAD_REPORT', res && res.data)
                })
                .catch(error=>{
                    commit('DOWNLOAD_REPORT', error)
                })
        },
        async showProviderLoginList({ commit }, data) {
            await AdminAPI.showProviderLoginList(data)
                .then(res=>{
                    commit('SHOW_PROVIDER_LOGIN_LIST', res && res.data)
                })
                .catch(error=>{
                    commit('SHOW_PROVIDER_LOGIN_LIST', error)
                })
        },
        async showProviderAtGlance({ commit }, data) {
            await AdminAPI.showProviderAtGlance(data)
                .then(res=>{
                    commit('SHOW_PROVIDER_AT_GLANCE', res && res.data)
                })
                .catch(error=>{
                    commit('SHOW_PROVIDER_AT_GLANCE', error)
                })
        },
        async showProviderSummary({ commit }, data) {
            await AdminAPI.showProviderSummary(data)
                .then(res=>{
                    commit('SHOW_PROVIDER_SUMMARY', res && res.data)
                })
                .catch(error=>{
                    commit('SHOW_PROVIDER_SUMMARY', error)
                })
        },
        async showProviderDisapprovalLogs({ commit }, data) {
            await AdminAPI.showProviderDisapprovalLogs(data)
                .then(res=>{
                    commit('SHOW_PROVIDER_DISAPPROVAL_LOGS', res && res.data)
                })
                .catch(error=>{
                    commit('SHOW_PROVIDER_DISAPPROVAL_LOGS', error)
                })
        },
        async showProviderApprovalLogs({ commit }, data) {
            await AdminAPI.showProviderApprovalLogs(data)
                .then(res=>{
                    commit('SHOW_PROVIDER_APPROVAL_LOGS', res && res.data)
                })
                .catch(error=>{
                    commit('SHOW_PROVIDER_APPROVAL_LOGS', error)
                })
        },
        recoverPasswordAdmin({ commit }, data) {
            AdminAPI.recoverPasswordAdmin(data)
                .then(res=>{
                    commit('RECOVER_PASSWORD', res && res.data)
                })
                .catch(error=>{
                    commit('RECOVER_PASSWORD', error)
                })
        },
        forgotPasswordAdmin({ commit }, data) {
            AdminAPI.forgotPasswordAdmin(data)
                .then(res=>{
                    commit('FORGOT_PASSWORD_ADMIN', res && res.data)
                })
                .catch(error=>{
                    commit('FORGOT_PASSWORD_ADMIN', error)
                })
        },
        changePasswordAdmin({ commit }, data) {
            AdminAPI.changePasswordAdmin(data)
                .then(res=>{
                    commit('CHANGE_PASSWORD_ADMIN', res && res.data)
                })
                .catch(error=>{
                    commit('CHANGE_PASSWORD_ADMIN', error)
                })
        },
        getUserInfo({ commit }) {
            AdminAPI.getUserInfo()
                .then(res=>{
                    commit('GET_USER_INFO', res && res.data)
                })
                .catch(error=>{
                    commit('GET_USER_INFO', error)
                })
        },
        showProviderLinks({ commit }, data) {
            AdminAPI.showProviderLinks(data)
                .then(res=>{
                    commit('SHOW_PROVIDER_LINKS', res && res.data)
                })
                .catch(error=>{
                    commit('SHOW_PROVIDER_LINKS', error)
                })
        },
        fetchProviders({ commit }, data) {
            AdminAPI.fetchProviders(data)
                .then(res=>{
                    commit('FETCH_PROVIDERS', res && res.data)
                })
                .catch(error=>{
                    commit('FETCH_PROVIDERS', error)
                })
        },
        linkProviders({ commit }, data) {
            AdminAPI.linkProviders(data)
                .then(res=>{
                    commit('LINK_PROVIDERS', res && res.data)
                })
                .catch(error=>{
                    commit('LINK_PROVIDERS', error)
                })
        },
        unlinkProviders({ commit }, data) {
            AdminAPI.unlinkProviders(data)
                .then(res=>{
                    commit('UNLINK_PROVIDERS', res && res.data)
                })
                .catch(error=>{
                    commit('UNLINK_PROVIDERS', error)
                })
        },
        signupProvider({ commit }, data) {
            AdminAPI.signupProvider(data)
                .then(res=>{
                    commit('SIGNUP_PROVIDER', res && res.data)
                })
                .catch(error=>{
                    commit('SIGNUP_PROVIDER', error)
                })
        },
        async login({ commit }, data) {
            await AdminAPI.login(data)
                .then(res=>{
                    // console.log('res: ', res)
                    commit('LOGIN', res && res.data)
                })
                .catch(error=>{
                    commit('LOGIN', error)
                })
        },
        async adminVerifySignup({ commit }, data) {
            await AdminAPI.adminVerifySignup(data)
                .then(res=>{
                    commit('ADMIN_VERIFY_SIGNUP', res && res.data)
                })
                .catch(error=>{
                    commit('ADMIN_VERIFY_SIGNUP', error)
                })
        },
        adminSignup({ commit }, data) {
            AdminAPI.adminSignup(data)
                .then(res=>{
                    commit('ADMIN_SIGNUP', res && res.data)
                })
                .catch(error=>{
                    commit('ADMIN_SIGNUP', error)
                })
        },
        async showMemberLoginList({ commit }, data) {
            await AdminAPI.showMemberLoginList(data).then((res) => {
                commit('SHOW_MEMBER_LOGIN_LIST', res.data)
            })
                .catch((err) => {
                    commit('SHOW_MEMBER_LOGIN_LIST', err)
                })
        },
        async showMemberApprovalLogs({ commit }, data) {
            await AdminAPI.showMemberApprovalLogs(data).then((res) => {
                commit('SHOW_MEMBER_APPROVAL_LOGS', res.data)
            })
                .catch((err) => {
                    commit('SHOW_MEMBER_APPROVAL_LOGS', err)
                })
        },
        async showMemberDisapprovalLogs({ commit }, data) {
            await AdminAPI.showMemberDisapprovalLogs(data).then((res) => {
                commit('SHOW_MEMBER_DISAPPROVAL_LOGS', res.data)
            })
                .catch((err) => {
                    commit('SHOW_MEMBER_DISAPPROVAL_LOGS', err)
                })
        },
        async showMemberSummaryTable({ commit }, data) {
            await AdminAPI.showMemberSummaryTable(data).then((res) => {
                commit('SHOW_MEMBER_SUMMARY_TABLE', res.data)
            })
                .catch((err) => {
                    commit('SHOW_MEMBER_SUMMARY_TABLE', err)
                })
        },
        async showAccountSummaryTable({ commit }, data) {
            await AdminAPI.showAccountSummaryTable(data).then((res) => {
                commit('SHOW_ACCOUNT_SUMMARY_TABLE', res.data)
            })
                .catch((err) => {
                    commit('SHOW_ACCOUNT_SUMMARY_TABLE', err)
                })
        },
        async showMemberAtGlance({ commit }, data) {
            await AdminAPI.showMemberAtGlance(data).then((res) => {
                commit('SHOW_MEMBER_AT_GLANCE', res.data)
            })
                .catch((err) => {
                    commit('SHOW_MEMBER_AT_GLANCE', err)
                })
        },
        async fetchProviderValidationLogs({ commit }, data) {
            await AdminAPI.showProviderValidationLogs(data).then((res) => {
                commit('SHOW_PROVIDER_VALIDATION_LOG', res.data)
            }).catch((err) => {
                commit('SHOW_PROVIDER_VALIDATION_LOG', err)
            })
        }
    },
    mutations: {
        IS_AUTHORIZED(state, isAuthorizedData) {
            state.isAuthorizedData = isAuthorizedData
        },

        /**
         * UTILS
         */
        FETCH_PORTAL_APPROVAL(state, fetchPortalApprovalData) {
            state.fetchPortalApprovalData = fetchPortalApprovalData
        },
        CANCEL_PORTAL_APPROVAL(state, cancelPortalApprovalData) {
            state.cancelPortalApprovalData = cancelPortalApprovalData
        },
        LIST_CANCELLED_PORTAL_APPROVALS(state, listCancelledPortalApprovalsData) {
            state.listCancelledPortalApprovalsData = listCancelledPortalApprovalsData
        },


        /**
         * ACU
        */
        LIST_CANCELLED_APPROVAL(state, listCancelledApprovalData) {
            state.listCancelledApprovalData = listCancelledApprovalData
        },
        CANCEL_ACU_APPROVAL(state, cancelAcuApprovalData) {
            state.cancelAcuApprovalData = cancelAcuApprovalData
        },
        EXTEND_LETTER(state, extendLetterData) {
            state.extendLetterData = extendLetterData
        },
        GENERATE_LETTER_REPORT(state, generateLetterReportData) {
            state.generateLetterReportData = generateLetterReportData
        },
        VIEW_LINKED_DIAGRATE(state, viewLinkedDiagRateData) {
            state.viewLinkedDiagRateData = viewLinkedDiagRateData
        },
        UNLINK_DIAG_RATE(state, unlinkDiagRateData) {
            state.unlinkDiagRateData = unlinkDiagRateData
        },
        LINK_DIAG_RATE(state, linkDiagRateData) {
            state.linkDiagRateData = linkDiagRateData
        },
        REMOVE_MEMBER_FROM_SCOPED_BENEFIT(state, removeMemberFromScopedBenefitData) {
            state.removeMemberFromScopedBenefitData = removeMemberFromScopedBenefitData
        },
        TOGGLE_ACU_PROGRESS(state, toggleAcuProgressData) {
            state.toggleAcuProgressData = toggleAcuProgressData
        },
        INSERT_MEMBER_TO_SCOPED_BENEFIT(state, insertMemberToScopedBenefitData) {
            state.insertMemberToScopedBenefitData = insertMemberToScopedBenefitData
        },
        FETCH_MEMBERS_OF_SCOPED_BENEFIT(state, fetchMembersOfScopedBenefitData) {
            state.fetchMembersOfScopedBenefitData = fetchMembersOfScopedBenefitData
        },
        DELETE_PROVIDER_ACU_INFO(state, deleteProviderAcuInfoData) {
            state.deleteProviderAcuInfoData = deleteProviderAcuInfoData
        },
        ADD_PROVIDER_ACU_INFO(state, addProviderAcuInfoData) {
            state.addProviderAcuInfoData = addProviderAcuInfoData
        },
        EDIT_PROVIDER_ACU_INFO(state, editProviderAcuInfoData) {
            state.editProviderAcuInfoData = editProviderAcuInfoData
        },
        VIEW_PROVIDER_ACU_INFO(state, viewProviderAcuInfoData) {
            state.viewProviderAcuInfoData = viewProviderAcuInfoData
        },
        CREATE_MSU_GROUP(state, createMsuGroupData) {
            state.createMsuGroupData = createMsuGroupData
        },
        DELETE_MSU_GROUP(state, deleteMsuGroupData) {
            state.deleteMsuGroupData = deleteMsuGroupData
        },
        DELETE_MSU_FROM_GROUP(state, deleteMsuFromGroupData) {
            state.deleteMsuFromGroupData = deleteMsuFromGroupData
        },
        INSERT_TO_MSU_GROUP(state, insertToMsuGroupData) {
            state.insertToMsuGroupData = insertToMsuGroupData
        },
        VIEW_MSU_GROUP(state, viewMsuGroupData) {
            state.viewMsuGroupData = viewMsuGroupData
        },
        EDIT_MSU_GROUP_NAME(state, editMsuGroupNameData) {
            state.editMsuGroupNameData = editMsuGroupNameData
        },
        LIST_MSU_GROUPS(state, listMsuGroupsData) {
            state.listMsuGroupsData = listMsuGroupsData
        },
        ADD_DIAGNOSTIC_TO_PACKAGE(state, addDiagnosticToPackageData) {
            state.addDiagnosticToPackageData = addDiagnosticToPackageData
        },
        DELETE_PACKAGE_DIAGNOSTIC(state, deletePackageDiagnosticData) {
            state.deletePackageDiagnosticData = deletePackageDiagnosticData
        },
        EDIT_DIAGNOSTIC_PACKAGE(state, editDiagnosticPackageData) {
            state.editDiagnosticPackageData = editDiagnosticPackageData
        },
        GET_PACKAGE_DIAGNOSTICS(state, getPackageDiagnosticsData) {
            state.getPackageDiagnosticsData = getPackageDiagnosticsData
        },
        SUGGEST_ACU_DIAGNOSTICS(state, acudiagnosticsuggestions) {
            state.acudiagnosticsuggestions = acudiagnosticsuggestions
        },
        DELETE_ENDORSEMENT_CONFIRMATION(state, deleteEndorsementConfirmationData) {
            state.deleteEndorsementConfirmationData = deleteEndorsementConfirmationData
        },
        DELETE_MEMBER_ENDORSEMENT_CONFIRMATION(state, deleteMemberFromEndorsementConfirmationData) {
            state.deleteMemberFromEndorsementConfirmationData = deleteMemberFromEndorsementConfirmationData
        },
        VIEW_ENDORSEMENT_CONFIRMATION(state, viewEndorsementConfirmationData) {
            state.viewEndorsementConfirmationData = viewEndorsementConfirmationData
        },
        SIGN_ENDORSEMENT_CONFIRMATION(state, signEndorsementConfirmationData) {
            state.signEndorsementConfirmationData = signEndorsementConfirmationData
        },
        LIST_ENDORSEMENT_CONFIRMATION(state, listEndorsementConfirmationData) {
            state.listEndorsementConfirmationData = listEndorsementConfirmationData
        },
        GENERATE_ENDORSEMENT_CONFIRMATION(state, generateEndorsementConfirmationData) {
            state.generateEndorsementConfirmationData = generateEndorsementConfirmationData
        },
        GET_STATUS_PROVISION(state, getStatusProvisionData) {
            state.getStatusProvisionData = getStatusProvisionData
        },
        DELETE_ACCOUNT_CLINIC(state, deleteAccountClinicData) {
            state.deleteAccountClinicData = deleteAccountClinicData
        },
        APPROVE_ACCOUNT_CLINIC(state, approveAccountClinicData) {
            state.approveAccountClinicData = approveAccountClinicData
        },
        INSERT_ACCOUNT_CLINIC(state, insertAccountClinicData) {
            state.insertAccountClinicData = insertAccountClinicData
        },
        VIEW_ACCOUNT_CLINICS(state, viewAccountClinicsData) {
            state.viewAccountClinicsData = viewAccountClinicsData
        },
        GENERATE_QUALIFIED_LIST(state, generateQualifiedListData) {
            state.generateQualifiedListData = generateQualifiedListData
        },
        REVALIDATE_ACU_APPROVAL(state, revalidateAcuApprovalData) {
            state.revalidateAcuApprovalData = revalidateAcuApprovalData
        },
        FETCH_ACU_APPROVAL(state, fetchAcuApprovalData) {
            state.fetchAcuApprovalData = fetchAcuApprovalData
        },
        DOWNLOAD_ACU_APPROVAL(state, downloadAcuApprovalData) {
            state.downloadAcuApprovalData = downloadAcuApprovalData
        },
        GENERATE_ACU_REPORT(state, generateAcuReportData) {
            state.generateAcuReportData = generateAcuReportData
        },
        SHOW_ACU_AT_GLANCE(state, showAcuAtGlanceData) {
            state.showAcuAtGlanceData = showAcuAtGlanceData
        },
        FETCH_ACU_ACCOUNT_SUMMARY(state, fetchAcuAccountSummaryData) {
            state.fetchAcuAccountSummaryData = fetchAcuAccountSummaryData
        },
        FETCH_ACU_MEMBER_SUMMARY(state, fetchAcuMemberSummaryData) {
            state.fetchAcuMemberSummaryData = fetchAcuMemberSummaryData
        },
        FETCH_ACU_DISAPPROVAL_LOGS(state, fetchAcuDisapprovalLogsData) {
            state.fetchAcuDisapprovalLogsData = fetchAcuDisapprovalLogsData
        },
        FETCH_ACU_APPROVAL_LOGS(state, fetchAcuApprovalLogsData) {
            state.fetchAcuApprovalLogsData = fetchAcuApprovalLogsData
        },
        FETCH_ACU_PROVIDERS_LOGIN_LIST(state, fetchAcuProviderLoginListData) {
            state.fetchAcuProviderLoginListData = fetchAcuProviderLoginListData
        },
        FETCH_ACU_PROVIDERS(state, fetchAcuProvidersData) {
            state.fetchAcuProvidersData = fetchAcuProvidersData
        },
        APPROVE_ACCOUNT_COVERAGE(state, approveAccountCoverageData) {
            state.approveAccountCoverageData = approveAccountCoverageData
        },
        APPROVE_ACU_STATUS(state, approveAcuStatusData) {
            state.approveAcuStatusData = approveAcuStatusData
        },
        ADD_ACCOUNT_COVERAGE(state, addAccountCoverageData) {
            state.addAccountCoverageData = addAccountCoverageData
        },
        DELETE_ACCOUNT_COVERAGE(state, deleteAccountCoverageData) {
            state.deleteAccountCoverageData = deleteAccountCoverageData
        },
        EDIT_ACCOUNT_COVERAGE(state, editAccountCoverageData) {
            state.editAccountCoverageData = editAccountCoverageData
        },
        VIEW_ACCOUNT_COVERAGES(state, viewAccountCoveragesData) {
            state.viewAccountCoveragesData = viewAccountCoveragesData
        },
        ADD_MSU_RATES(state, addMsuRatesData) {
            state.addMsuRatesData = addMsuRatesData
        },
        DELETE_MSU_RATES(state, deleteMsuRatesData) {
            state.deleteMsuRatesData = deleteMsuRatesData
        },
        EDIT_MSU_RATES(state, editMsuRatesData) {
            state.editMsuRatesData = editMsuRatesData
        },
        GET_MSU_RATES(state, getMsuRatesData) {
            state.getMsuRatesData = getMsuRatesData
        },
        EDIT_PROVIDER_ACCOUNT(state, editProviderAccountData) {
            state.editProviderAccountData = editProviderAccountData
        },
        DISABLE_PROVIDER_ACCOUNT(state, disableProviderAccountData) {
            state.disableProviderAccountData = disableProviderAccountData
        },
        ACU_ACTIVE_LIST(state, acuActiveListData) {
            state.acuActiveListData = acuActiveListData
        },
        SET_ACU_ACTIVE_LIST_ABORT_CONTROLLER(state, controller) {
            state.acuActiveListAbortController = controller
        },
        BUMP_ACU_ACTIVE_LIST_REQUEST_ID(state) {
            state.acuActiveListRequestId++
        },
        TOGGLE_ACU_STATUS(state, toggleAcuStatusData) {
            state.toggleAcuStatusData = toggleAcuStatusData
        },
        VIEW_LEDGER(state, viewLedgerData) {
            state.viewLedgerData = viewLedgerData
        },
        DOWNLOAD_LEDGER_CLAIMS(state, downloadLedgerClaimsData) {
            state.downloadLedgerClaimsData = downloadLedgerClaimsData
        },
        FETCH_LIST_LEDGERS(state, fetchListLedgersData) {
            state.fetchListLedgersData = fetchListLedgersData
        },
        FETCH_LIST_MSU_CLAIMS(state, providerListClaimsData) {
            state.providerListClaimsData = providerListClaimsData
        },
        DOWNLOAD_APPROVAL_MEMB(state, downloadApprovalMembData) {
            state.downloadApprovalMembData = downloadApprovalMembData
        },
        DOWNLOAD_APPROVAL_PROVIDER(state, downloadApprovalProviderData) {
            state.downloadApprovalProviderData = downloadApprovalProviderData
        },
        DOWNLOAD_REPORT_MEMB(state, downloadReportMembData) {
            state.downloadReportMembData = downloadReportMembData
        },
        DOWNLOAD_REPORT(state, downloadReportData) {
            state.downloadReportData = downloadReportData
        },
        SHOW_PROVIDER_LOGIN_LIST(state, showProviderLoginListData) {
            state.showProviderLoginListData = showProviderLoginListData
        },
        SHOW_PROVIDER_AT_GLANCE(state, showProviderAtGlanceData) {
            state.showProviderAtGlanceData = showProviderAtGlanceData
        },
        SHOW_PROVIDER_SUMMARY(state, showProviderSummaryData) {
            state.showProviderSummaryData = showProviderSummaryData
        },
        SHOW_PROVIDER_DISAPPROVAL_LOGS(state, showProviderDisapprovalLogsData) {
            state.showProviderDisapprovalLogsData = showProviderDisapprovalLogsData
        },
        SHOW_PROVIDER_APPROVAL_LOGS(state, showProviderApprovalLogsData) {
            state.showProviderApprovalLogsData = showProviderApprovalLogsData
        },
        RECOVER_PASSWORD(state, recoverPasswordAdminData) {
            state.recoverPasswordAdminData = recoverPasswordAdminData
        },
        FORGOT_PASSWORD_ADMIN(state, forgotPasswordAdminData) {
            state.forgotPasswordAdminData = forgotPasswordAdminData
        },
        CHANGE_PASSWORD_ADMIN(state, changePasswordAdminData) {
            state.changePasswordAdminData = changePasswordAdminData
        },
        GET_USER_INFO(state, getUserInfoData) {
            state.getUserInfoData = getUserInfoData
        },
        SHOW_PROVIDER_LINKS(state, showProviderLinksData) {
            state.showProviderLinksData = showProviderLinksData
        },
        FETCH_PROVIDERS(state, fetchProvidersData) {
            state.fetchProvidersData = fetchProvidersData
        },
        LINK_PROVIDERS(state, linkProvidersData) {
            state.linkProvidersData = linkProvidersData
        },
        UNLINK_PROVIDERS(state, unlinkProvidersData) {
            state.unlinkProvidersData = unlinkProvidersData
        },
        SIGNUP_PROVIDER(state, signupProviderData) {
            state.signupProviderData = signupProviderData
        },
        LOGIN(state, loginData) {
            state.loginData = loginData
        },
        ADMIN_VERIFY_SIGNUP(state, adminVerifySignupData) {
            state.adminVerifySignupData = adminVerifySignupData
        },
        ADMIN_SIGNUP(state, adminSignupData) {
            state.adminSignupData = adminSignupData
        },
        SHOW_MEMBER_LOGIN_LIST(state, showMemberLoginListData) {
            state.showMemberLoginListData = showMemberLoginListData
        },
        SHOW_MEMBER_APPROVAL_LOGS(state, showMemberApprovalLogsData) {
            state.showMemberApprovalLogsData = showMemberApprovalLogsData
        },
        SHOW_MEMBER_DISAPPROVAL_LOGS(state, showMemberDisapprovalLogsData) {
            state.showMemberDisapprovalLogsData = showMemberDisapprovalLogsData
        },
        SHOW_MEMBER_SUMMARY_TABLE(state, showMemberSummaryTableData) {
            state.showMemberSummaryTableData = showMemberSummaryTableData
        },
        SHOW_ACCOUNT_SUMMARY_TABLE(state, showAccountSummaryTableData) {
            state.showAccountSummaryTableData = showAccountSummaryTableData
        },
        SHOW_MEMBER_AT_GLANCE(state, showMemberAtGlanceData) {
            state.showMemberAtGlanceData = showMemberAtGlanceData
        },
        SHOW_PROVIDER_VALIDATION_LOG(state, showProviderValidationLog) {
            state.showProviderValidationLog = showProviderValidationLog
        }
    },
    getters: {
        isAuthorizedData(state) {
            return state.isAuthorizedData
        },
        
        /**
         * UTILS
         */
        fetchPortalApprovalData(state) {
            return state.fetchPortalApprovalData
        },
        cancelPortalApprovalData(state) {
            return state.cancelPortalApprovalData
        },
        listCancelledPortalApprovalsData(state) {
            return state.listCancelledPortalApprovalsData
        },

        /**
         * ACU
         */
        listCancelledApprovalData(state) {
            return state.listCancelledApprovalData
        },
        cancelAcuApprovalData(state) {
            return state.cancelAcuApprovalData
        },
        extendLetterData(state) {
            return state.extendLetterData
        },
        generateLetterReportData(state) {
            return state.generateLetterReportData
        },
        viewLinkedDiagRateData(state) {
            return state.viewLinkedDiagRateData
        },
        unlinkDiagRateData(state) {
            return state.unlinkDiagRateData
        },
        linkDiagRateData(state) {
            return state.linkDiagRateData
        },
        removeMemberFromScopedBenefitData(state) {
            return state.removeMemberFromScopedBenefitData
        },
        toggleAcuProgressData(state) {
            return state.toggleAcuProgressData
        },
        insertMemberToScopedBenefitData(state) {
            return state.insertMemberToScopedBenefitData
        },
        fetchMembersOfScopedBenefitData(state) {
            return state.fetchMembersOfScopedBenefitData
        },
        deleteProviderAcuInfoData(state) {
            return state.deleteProviderAcuInfoData
        },
        addProviderAcuInfoData(state) {
            return state.addProviderAcuInfoData
        },
        editProviderAcuInfoData(state) {
            return state.editProviderAcuInfoData
        },
        viewProviderAcuInfoData(state) {
            return state.viewProviderAcuInfoData
        },
        deleteMsuFromGroupData(state) {
            return state.deleteMsuFromGroupData
        },
        createMsuGroupData(state) {
            return state.createMsuGroupData
        },
        deleteMsuGroupData(state) {
            return state.deleteMsuGroupData
        },
        insertToMsuGroupData(state) {
            return state.insertToMsuGroupData
        },
        viewMsuGroupData(state) {
            return state.viewMsuGroupData
        },
        editMsuGroupNameData(state) {
            return state.editMsuGroupNameData
        },
        listMsuGroupsData(state) {
            return state.listMsuGroupsData
        },
        addDiagnosticToPackageData(state) {
            return state.addDiagnosticToPackageData
        },
        deletePackageDiagnosticData(state) {
            return state.deletePackageDiagnosticData
        },
        editDiagnosticPackageData(state) {
            return state.editDiagnosticPackageData
        },
        getPackageDiagnosticsData(state) {
            return state.getPackageDiagnosticsData
        },
        getAcuDiagnosticSuggestions(state) {
            return state.acudiagnosticsuggestions
        },
        deleteEndorsementConfirmationData(state) {
            return state.deleteEndorsementConfirmationData
        },
        deleteMemberFromEndorsementConfirmationData(state) {
            return state.deleteMemberFromEndorsementConfirmationData
        },
        viewEndorsementConfirmationData(state) {
            return state.viewEndorsementConfirmationData
        },
        signEndorsementConfirmationData(state) {
            return state.signEndorsementConfirmationData
        },
        listEndorsementConfirmationData(state) {
            return state.listEndorsementConfirmationData
        },
        generateEndorsementConfirmationData(state) {
            return state.generateEndorsementConfirmationData
        },
        getStatusProvisionData(state) {
            return state.getStatusProvisionData
        },
        deleteAccountClinicData(state) {
            return state.deleteAccountClinicData
        },
        approveAccountClinicData(state) {
            return state.approveAccountClinicData
        },
        insertAccountClinicData(state) {
            return state.insertAccountClinicData
        },
        viewAccountClinicsData(state) {
            return state.viewAccountClinicsData
        },
        generateQualifiedListData(state) {
            return state.generateQualifiedListData
        },
        revalidateAcuApprovalData(state) {
            return state.revalidateAcuApprovalData
        },
        fetchAcuApprovalData(state) {
            return state.fetchAcuApprovalData
        },
        downloadAcuApprovalData(state) {
            return state.downloadAcuApprovalData
        },
        generateAcuReportData(state) {
            return state.generateAcuReportData
        },
        showAcuAtGlanceData(state) {
            return state.showAcuAtGlanceData
        },
        fetchAcuAccountSummaryData(state) {
            return state.fetchAcuAccountSummaryData
        },
        fetchAcuMemberSummaryData(state) {
            return state.fetchAcuMemberSummaryData
        },
        fetchAcuDisapprovalLogsData(state) {
            return state.fetchAcuDisapprovalLogsData
        },
        fetchAcuApprovalLogsData(state) {
            return state.fetchAcuApprovalLogsData
        },
        fetchAcuProviderLoginListData(state) {
            return state.fetchAcuProviderLoginListData
        },
        fetchAcuProvidersData(state) {
            return state.fetchAcuProvidersData
        },
        approveAccountCoverageData(state) {
            return state.approveAccountCoverageData
        },
        approveAcuStatusData(state) {
            return state.approveAcuStatusData
        },
        addAccountCoverageData(state) {
            return state.addAccountCoverageData
        },
        deleteAccountCoverageData(state) {
            return state.deleteAccountCoverageData
        },
        editAccountCoverageData(state) {
            return state.editAccountCoverageData
        },
        viewAccountCoveragesData(state) {
            return state.viewAccountCoveragesData
        },
        addMsuRatesData(state) {
            return state.addMsuRatesData
        },
        acuActiveListData(state) {
            return state.acuActiveListData
        },
        toggleAcuStatusData(state) {
            return state.toggleAcuStatusData
        },
        getMsuRatesData(state) {
            return state.getMsuRatesData
        },
        editMsuRatesData(state) {
            return state.editMsuRatesData
        },
        deleteMsuRatesData(state) {
            return state.deleteMsuRatesData
        },

        /**
         *
         */
        editProviderAccountData(state) {
            return state.editProviderAccountData
        },
        disableProviderAccountData(state) {
            return state.disableProviderAccountData
        },
        viewLedgerData(state) {
            return state.viewLedgerData
        },
        downloadLedgerClaimsData(state) {
            return state.downloadLedgerClaimsData
        },
        fetchListLedgersData(state) {
            return state.fetchListLedgersData
        },
        fetchProviderClaimsData(state) {
            return state.providerListClaimsData
        },
        downloadApprovalMembData(state) {
            return state.downloadApprovalMembData
        },
        downloadApprovalProviderData(state) {
            return state.downloadApprovalProviderData
        },
        downloadReportMembData(state) {
            return state.downloadReportMembData
        },
        downloadReportData(state) {
            return state.downloadReportData
        },
        showProviderLoginListData(state) {
            return state.showProviderLoginListData
        },
        showProviderAtGlanceData(state) {
            return state.showProviderAtGlanceData
        },
        showProviderSummaryData(state) {
            return state.showProviderSummaryData
        },
        showProviderDisapprovalLogsData(state) {
            return state.showProviderDisapprovalLogsData
        },
        showProviderApprovalLogsData(state) {
            return state.showProviderApprovalLogsData
        },
        getProviderValidationLogs(state) {
            return state.showProviderValidationLog
        },
        recoverPasswordAdminData(state) {
            return state.recoverPasswordAdminData
        },
        forgotPasswordAdminData(state) {
            return state.forgotPasswordAdminData
        },
        changePasswordAdminData(state) {
            return state.changePasswordAdminData
        },
        getUserInfoData(state) {
            return state.getUserInfoData
        },
        showProviderLinksData(state) {
            return state.showProviderLinksData
        },
        fetchProvidersData(state) {
            return state.fetchProvidersData
        },
        linkProvidersData(state) {
            return state.linkProvidersData
        },
        unlinkProvidersData(state) {
            return state.unlinkProvidersData
        },
        signupProviderData(state) {
            return state.signupProviderData
        },
        loginData(state) {
            return state.loginData
        },
        adminVerifySignupData(state) {
            return state.adminVerifySignupData
        },
        adminSignupData(state) {
            return state.adminSignupData
        },
        showMemberLoginListData(state) {
            return state.showMemberLoginListData
        },
        showMemberApprovalLogsData(state) {
            return state.showMemberApprovalLogsData
        },
        showMemberDisapprovalLogsData(state) {
            return state.showMemberDisapprovalLogsData
        },
        showMemberSummaryTableData(state) {
            return state.showMemberSummaryTableData
        },
        showAccountSummaryTableData(state) {
            return state.showAccountSummaryTableData
        },
        showMemberAtGlanceData(state) {
            return state.showMemberAtGlanceData
        }
    }
}
